import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, Subscriber } from "rxjs";
import { Filter } from "../model/filters/filter";
import { MatchAll } from "../model/filters/match-all";
import { EnvironmentHelper } from "./env.helper";
import {
  HttpClient,
  HttpErrorResponse,
  HttpResponse,
  HttpResponseBase,
} from "@angular/common/http";
import { Messages } from "../model/messages";
import { StatusService } from "./status.service";
import { UsersService } from "./users.service";
import { BranchService } from "./branch.service";
import { PrioritiesService } from "./priorities.service";
import { DepartmentsService } from "./departaments.service";
import { Active } from "../model/filters/active";
import { ByStatus } from "../model/filters/by-status";
import { Not } from "../model/filters/not";

@Injectable({
  providedIn: "root",
})
export class FilterService {
  public currentFilter = new BehaviorSubject<Filter>(new MatchAll([]));
  private appliedFilters: any[] = [];
  private apiUrl: string;

  constructor(
    private env: EnvironmentHelper,
    private http: HttpClient,
    private statusService: StatusService,
    private user: UsersService,
    private branch: BranchService,
    private priority: PrioritiesService,
    private department: DepartmentsService
  ) {
    const savedFilters = localStorage.getItem("appliedFilters");
    if (savedFilters) {
      const filters = JSON.parse(savedFilters);
      this.statusService.makeLabel(1).subscribe((s) => {
        this.user.makeLabel(1).subscribe((a) => {});
        this.branch.makeLabel(1).subscribe((a) => {});
        this.priority.makeLabel(1).subscribe((a) => {});
        this.department.makeLabel(1).subscribe((a) => {});
        this.currentFilter.next(filters);
      });
    }
    this.apiUrl = `${env.apiBaseUrl}ticket/filter`;
  }

  addFilter(filter: Filter): void {
    if (!filter.identifier) {
      filter.identifier = Date.now();
    }

    const current = this.currentFilter.value as MatchAll;

    const newFilterCodes = this.extractCodes(filter);

    current.filters = current.filters.filter((f) => {
      const existingCodes = this.extractCodes(f);
      return !existingCodes.some((code) => newFilterCodes.includes(code));
    });

    current.filters.push(filter);

    this.saveFiltersToLocalStorage();
    this.currentFilter.next(current);
  }
  private extractCodes(filter: Filter): string[] {
    if (!filter) return [];

    if (Array.isArray((filter as any).filters)) {
      const innerCodes = (filter as any).filters.flatMap((f: any) =>
        this.extractCodes(f)
      );
      return innerCodes;
    }

    return [filter.code];
  }

  removeFilter(filter: Filter): void {
    const current = this.currentFilter.value as MatchAll;

    current.filters = current.filters.filter(
      (f) => f.identifier !== filter.identifier
    );

    this.saveFiltersToLocalStorage();
    this.currentFilter.next(current);
  }

  triggerFilter(): void {
    this.currentFilter.next(this.currentFilter.value);
  }

  public get filterObservable(): Observable<Filter> {
    return this.currentFilter.asObservable();
  }

  public get filterCurrent(): Filter {
    const current = this.currentFilter.value;
    return current;
  }

  private saveFiltersToLocalStorage() {
    localStorage.setItem("appliedFilters", JSON.stringify(this.filterCurrent));
  }

  clearAllFilters() {
    this.currentFilter.next(new MatchAll([]));

    this.saveFiltersToLocalStorage();
  }

  setStandardFilter() {
    const not = new Not(new Array<Filter>());
    not.filters.push(new ByStatus(3));

    this.clearAllFilters();

    this.addFilter(not);
    this.addFilter(new Active());
  }
  updateFilters(filters: Filter[]) {
    const current = this.currentFilter.value as MatchAll;

    current.filters = filters;

    this.saveFiltersToLocalStorage();
    this.currentFilter.next(current);
  }
}
